<app-header [sidenav]="leftSidenav"></app-header>
<ngx-spinner [name]="'default'" type="ball-beat"></ngx-spinner>

<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #leftSidenav mode="side" opened >
        <app-left-menu></app-left-menu>
    </mat-sidenav>
    <mat-sidenav-content [@onMainContentChange]="onSideNavChange ? 'open': 'close'" class="side">
        <div class="main_content">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
